function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.93457 2.52356C0.93457 1.41899 1.83 0.52356 2.93457 0.52356H22.9346C24.0391 0.52356 24.9346 1.41899 24.9346 2.52356V22.5236C24.9346 23.6281 24.0391 24.5236 22.9346 24.5236H2.93457C1.83 24.5236 0.93457 23.6281 0.93457 22.5236V2.52356Z",
  fill: "#FDFDFD"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6.55615,
  y: 4.33887,
  width: 7.37964,
  height: 4,
  transform: "rotate(90 6.55615 4.33887)",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 6.55615,
  y: 13.3286,
  width: 7.37964,
  height: 4,
  transform: "rotate(90 6.55615 13.3286)",
  fill: "#444444"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 12.1418,
  y: 4.33887,
  width: 7.37964,
  height: 4,
  transform: "rotate(90 12.1418 4.33887)",
  fill: "#444444"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 12.1418,
  y: 13.3286,
  width: 7.37964,
  height: 4,
  transform: "rotate(90 12.1418 13.3286)",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 17.7273,
  y: 4.33887,
  width: 7.37964,
  height: 4,
  transform: "rotate(90 17.7273 4.33887)",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 17.7273,
  y: 13.3286,
  width: 7.37964,
  height: 4,
  transform: "rotate(90 17.7273 13.3286)",
  fill: "#444444"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 23.313,
  y: 4.33887,
  width: 7.37964,
  height: 4,
  transform: "rotate(90 23.313 4.33887)",
  fill: "#444444"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 23.313,
  y: 13.3286,
  width: 7.37964,
  height: 4,
  transform: "rotate(90 23.313 13.3286)",
  fill: "black"
});

function SvgWrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrap);
export default __webpack_public_path__ + "static/media/wrap.d6f747ec.svg";
export { ForwardRef as ReactComponent };